import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ShieldCheck } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { API } from "../lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("gis_admin_token", res.data.token);
      localStorage.setItem("gis_admin_email", res.data.email);
      toast.success("Signed in");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] grid place-items-center px-4" data-testid="admin-login">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img
            src="/logo.png"
            alt="Greenville Integrated Solutions"
            className="h-32 w-auto object-contain mx-auto"
          />
          <h1 className="font-display font-bold text-2xl text-slate-900 mt-4">Admin sign in</h1>
        </div>
        <form onSubmit={submit} className="bg-white border border-slate-200 p-6 space-y-4">
          <div className="space-y-1.5">
            <Label className="text-xs font-mono uppercase tracking-wider text-slate-700">Email</Label>
            <Input data-testid="login-input-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-none border-slate-300" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs font-mono uppercase tracking-wider text-slate-700">Password</Label>
            <Input data-testid="login-input-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-none border-slate-300" />
          </div>
          <Button data-testid="login-submit-btn" disabled={loading} type="submit" className="w-full rounded-none bg-[#1E3A6B] hover:bg-[#172F58] h-11">
            {loading ? <><Loader2 size={16} className="animate-spin mr-2" />Signing in…</> : "Sign in"}
          </Button>
        </form>
        <p className="text-xs text-center text-slate-500 mt-4">
          Default: <span className="font-mono">mhasoneh@greenvilleis.com</span> / set in env
        </p>
      </div>
    </div>
  );
}
